import {
  Suspense,
  type LazyExoticComponent,
  type ComponentType,
  type JSX,
} from 'react';

export function withSuspense<P extends JSX.IntrinsicAttributes>(
  Component: LazyExoticComponent<ComponentType<P>>,
  fallback: React.ReactNode = null
) { 
  return (props: P) => ( 
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  );
}
